// extracted by mini-css-extract-plugin
module.exports = {"sticker":"sticker_sticker__2okyT","rim":"sticker_rim__ssdsU"};